"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const applyInheritance = sizes => {
  let prevSize;
  return sizes.map((size, index) => {
    if (size !== undefined) {
      prevSize = size;
      return size;
    }
    if (index) {
      const value = prevSize;
      return value;
    }
    return undefined;
  });
};
var _default = exports.default = applyInheritance;